import React from "react";
import "./pagination.scss"
const PaginationComponent = ({ pagination, setPagination, unscroll }) => {
	const handlePageChange = (num) => {
		let pagescroll = unscroll ? false : true;
		//const isBrowser = typeof window !== `undefined`
		setPagination({ ...pagination, "active": num, })
		if (pagescroll) {
			window.scrollTo({
				top: 0,
				behavior: 'smooth',
				block: 'center',
			})
		}
	}
	let startPage, endPage;
	if (pagination.numPages <= 5) {
		startPage = 1;
		endPage = pagination.numPages;
	} else {
		if (pagination.active <= 3) {
			startPage = 1;
			endPage = 5;
		} else if (pagination.active + 2 >= pagination.numPages) {
			startPage = pagination.numPages - 4;
			endPage = pagination.numPages;
		} else {
			startPage = pagination.active - 2;
			endPage = pagination.active + 2;
		}
	}

	let pages = [...Array(endPage + 1 - startPage).keys()].map(
		i => startPage + i
	);
	return (
		<div className={'paginationCont'}>
			<div className={'paginationStyle'}>
				<div className={'pagination'}>
					<ul>
						{pagination.active != 1 && pagination.numPages > 5 && (<li>
							<button
								// disabled={pagination.active === 1}
								onClick={() => handlePageChange(1)}
								className={'First'}
							>
								{`First`}
							</button>
						</li>)}
						{pagination.active != 1 && (<li>
							<button
								// disabled={pagination.active === 1}
								onClick={() => handlePageChange(pagination.active - 1)}
							>
								{`<`}
							</button>
						</li>)}
						{pages.map((page, index) => (
							<li key={index}>
								<button
									className={pagination.active === page ? 'active' : ""}
									onClick={() => handlePageChange(page)}
								>
									{page}
								</button>
							</li>
						))}
						{pagination.active != pagination.numPages && (<li>
							<button
								// disabled={pagination.active === pagination.numPages}
								onClick={() => handlePageChange(pagination.active + 1)}
							>
								{`>`}
							</button>
						</li>)}
						{pagination.active != pagination.numPages && pagination.numPages > 5 && (<li>
							<button
								// disabled={pagination.active === pagination.numPages}
								className={'Last'}
								onClick={() => handlePageChange(pagination.numPages)}
							>
								{`Last`}
							</button>
						</li>)}
					</ul>
				</div>
			</div>
		</div>
	);

}

export default PaginationComponent;
